import React from 'react';
import { colors } from 'ui_system/compass/utils';

const Download = (props) => {
  const { fill = colors.text.icon } = props;

  return (
    <svg
      height="32px"
      width="32px"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>download-icon</title>
      <g
        id="download-icon"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <rect id="Rectangle" x={0} y={0} width={32} height={32} />
        <path
          d="M32,28 L32,30 L0,30 L0,28 L32,28 Z M17,2 L17,18.163 L25.5021667,10 L27,11.4381693 L16,22 L5,11.4381693 L6.49783333,10 L15,18.163 L15,2 L17,2 Z"
          id="color"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export default Download;
